"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("./utils");

function applyMiddleware() {
  var middlewares = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    middlewares[_i] = arguments[_i];
  }

  return function (createStore) {
    return function () {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      var store = createStore.apply(void 0, args);

      var _dispatch;

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          var args = [];

          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }

          return _dispatch.apply(void 0, args);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = utils_1.compose.apply(void 0, chain)(store.dispatch);
      return __assign({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

exports.default = applyMiddleware;